module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.maskLayer) ? _c('div', {
    staticClass: "maskLayer"
  }, [(_vm.allModelShow == 1) ? _c('div', {
    staticClass: "bgAddAccountModel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modelTitle"
  }, [_vm._v("添加账号")]), _vm._v(" "), _c('el-form', {
    ref: "formAddAccount",
    staticClass: "addAccountForm",
    attrs: {
      "model": _vm.formAddAccount,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录账号：",
      "prop": "loginAccount"
    }
  }, [_c('i', {
    staticClass: "stars1"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.formAddAccount.loginAccount),
      callback: function($$v) {
        _vm.$set(_vm.formAddAccount, "loginAccount", $$v)
      },
      expression: "formAddAccount.loginAccount"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginAccountHint"
  }, [_vm._v(_vm._s(_vm.accountError))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "后台权限：",
      "prop": "type"
    }
  }, [_c('div', [_c('span', [_vm._v("企业趋势")]), _vm._v(" "), _c('span', [_vm._v("企业统计")])]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.formAddAccount.type),
      callback: function($$v) {
        _vm.$set(_vm.formAddAccount, "type", $$v)
      },
      expression: "formAddAccount.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "企业订单",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业管理",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业观察",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业网站",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "系统设置",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "后台设置",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "初始密码：",
      "prop": "initialPass"
    }
  }, [_c('i', {
    staticClass: "stars1"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formAddAccount.initialPass),
      callback: function($$v) {
        _vm.$set(_vm.formAddAccount, "initialPass", $$v)
      },
      expression: "formAddAccount.initialPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginAccountHint"
  }, [_vm._v(_vm._s(_vm.InitialPassError))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addAccountOnSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.addAccountCancel(_vm.formAddAccount)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1) : (_vm.allModelShow == 2) ? _c('div', {
    staticClass: "bgAddAccountModel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modelTitle"
  }, [_vm._v("修改账号")]), _vm._v(" "), _c('el-form', {
    ref: "formEditAccount",
    staticClass: "addAccountForm",
    attrs: {
      "model": _vm.formEditAccount,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录账号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.personageAccData.account))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "后台权限："
    }
  }, [_c('div', [_c('span', [_vm._v("企业趋势")]), _vm._v(" "), _c('span', [_vm._v("企业统计")])]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.formEditAccount.type),
      callback: function($$v) {
        _vm.$set(_vm.formEditAccount, "type", $$v)
      },
      expression: "formEditAccount.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "企业订单",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业管理",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业观察",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业网站",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "系统设置",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "后台设置",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重置密码：",
      "prop": "initialPass"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formEditAccount.initialPass),
      callback: function($$v) {
        _vm.$set(_vm.formEditAccount, "initialPass", $$v)
      },
      expression: "formEditAccount.initialPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginAccountHint"
  }, [_vm._v(_vm._s(_vm.editInitialPassError))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.editAccountOnSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.editAccountCancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1) : (_vm.allModelShow == 3) ? _c('div', {
    staticClass: "bgDelAccountModel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "DelAcc-content"
  }, [_c('p', [_vm._v("是否删除登录账号\n                        "), _c('span', [_vm._v(" \"" + _vm._s(_vm.deleteAccount) + "\" ")]), _vm._v("?")]), _vm._v(" "), _c('div', {
    staticClass: "DelAcc-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.DelAccountOnSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.DelAccountCancel
    }
  }, [_vm._v("取消")])], 1)])]) : (_vm.allModelShow == 4) ? _c('div', {
    staticClass: "bgAddAccountModel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modelTitle"
  }, [_vm._v("管理操作")]), _vm._v(" "), _c('el-form', {
    ref: "formManageOperation",
    staticClass: "ManageOperationForm",
    attrs: {
      "model": _vm.formManageOperation,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册账号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cpMangeDatas.email))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cpMangeDatas.company))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体验坐席数："
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.formManageOperation.freeWaiterPara),
      callback: function($$v) {
        _vm.$set(_vm.formManageOperation, "freeWaiterPara", $$v)
      },
      expression: "formManageOperation.freeWaiterPara"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "留言消息："
    }
  }, [_c('div', {
    staticClass: "similarityBefore"
  }), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.leaveMsgParaChange
    },
    model: {
      value: (_vm.formManageOperation.leaveMsgPara),
      callback: function($$v) {
        _vm.$set(_vm.formManageOperation, "leaveMsgPara", $$v)
      },
      expression: "formManageOperation.leaveMsgPara"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.cpMgDisabled,
      "label": "1"
    }
  }, [_vm._v("有限制")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.cpMgDisabled
    },
    on: {
      "change": _vm.leaveMgChange
    },
    model: {
      value: (_vm.formManageOperation.leaveMsgParaInput),
      callback: function($$v) {
        _vm.$set(_vm.formManageOperation, "leaveMsgParaInput", $$v)
      },
      expression: "formManageOperation.leaveMsgParaInput"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.cpMgDisabled,
      "label": "2"
    }
  }, [_vm._v("无限制")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机器人消息："
    }
  }, [_c('div', {
    staticClass: "similarityBefore"
  }), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.rbMsgParaChange
    },
    model: {
      value: (_vm.formManageOperation.rbMsgPara),
      callback: function($$v) {
        _vm.$set(_vm.formManageOperation, "rbMsgPara", $$v)
      },
      expression: "formManageOperation.rbMsgPara"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.cpMgDisabled,
      "label": "1"
    }
  }, [_vm._v("有限制")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.cpMgDisabled
    },
    on: {
      "change": _vm.rbChange
    },
    model: {
      value: (_vm.formManageOperation.rbMsgParaInput),
      callback: function($$v) {
        _vm.$set(_vm.formManageOperation, "rbMsgParaInput", $$v)
      },
      expression: "formManageOperation.rbMsgParaInput"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.cpMgDisabled,
      "label": "2"
    }
  }, [_vm._v("无限制")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.manageOperationOnSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.manageOperationCancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1) : (_vm.allModelShow == 5) ? _c('div', {
    staticClass: "modifyPassword"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modelTitle"
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-form', {
    ref: "formModifyPassword",
    staticClass: "addModifyForm",
    attrs: {
      "model": _vm.formModifyPassword,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码："
    }
  }, [_c('span', {
    staticClass: "redStar"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formModifyPassword.originPassword),
      callback: function($$v) {
        _vm.$set(_vm.formModifyPassword, "originPassword", $$v)
      },
      expression: "formModifyPassword.originPassword"
    }
  }), _vm._v(" "), (_vm.modifyPasswordTriggeringCon.originPassword.empty) ? _c('div', {
    staticClass: "modifyPasswordHint"
  }, [_vm._v("\n                            原密码不能为空\n                        ")]) : (_vm.modifyPasswordTriggeringCon.originPassword.invalid) ? _c('div', {
    staticClass: "modifyPasswordHint"
  }, [_vm._v("\n                            原密码错误\n                        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码："
    }
  }, [_c('span', {
    staticClass: "redStar"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formModifyPassword.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.formModifyPassword, "newPassword", $$v)
      },
      expression: "formModifyPassword.newPassword"
    }
  }), _vm._v(" "), (_vm.modifyPasswordTriggeringCon.newPassword.empty) ? _c('div', {
    staticClass: "modifyPasswordHint"
  }, [_vm._v("请输入新密码\n                        ")]) : (_vm.modifyPasswordTriggeringCon.newPassword.limit) ? _c('div', {
    staticClass: "modifyPasswordHint"
  }, [_vm._v("\n                            密码不能少于6个字符\n                        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码："
    }
  }, [_c('span', {
    staticClass: "redStar"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formModifyPassword.repeatPassword),
      callback: function($$v) {
        _vm.$set(_vm.formModifyPassword, "repeatPassword", $$v)
      },
      expression: "formModifyPassword.repeatPassword"
    }
  }), _vm._v(" "), (_vm.modifyPasswordTriggeringCon.repeatPassword.empty) ? _c('div', {
    staticClass: "modifyPasswordHint"
  }, [_vm._v("\n                            请再次输入新密码\n                        ")]) : (_vm.modifyPasswordTriggeringCon.repeatPassword.identical) ? _c('div', {
    staticClass: "modifyPasswordHint"
  }, [_vm._v("与第一次输入的新密码不一致\n                        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "m-token-setting",
    attrs: {
      "label": "M令牌："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.mTokenStatus.enabled ? '已开启' : '未开启'))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": _vm.mTokenStatus.enabled ? 'danger' : 'success',
      "loading": _vm.mTokenLoading
    },
    on: {
      "click": _vm.toggleMToken
    }
  }, [_vm._v(_vm._s(_vm.mTokenStatus.enabled ? '关闭' : '开启'))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.comfirmPassword
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.addModifyPasswordCancel()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('m-token-dialog', {
    ref: "mTokenRef",
    on: {
      "verified": _vm.mTokenVerified
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-style"
  }, [_c('div', {
    staticClass: "top-style-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-style-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-style"
  }, [_c('div', {
    staticClass: "top-style-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-style-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DelAcc-title"
  }, [_c('div', {
    staticClass: "title-style"
  }), _vm._v(" "), _c('p', [_vm._v("提示!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-style"
  }, [_c('div', {
    staticClass: "top-style-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-style-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-style"
  }, [_c('div', {
    staticClass: "top-style-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-style-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66aa57bc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 555
// module chunks = 1